import type { DocumentCardProps } from '../../Documents/DocumentCard';
import { DocumentCard } from '../../Documents/DocumentCard';

export function IncomeDocumentCard(props: Omit<DocumentCardProps, 'documentLabel'>) {
  return <DocumentCard {...props} documentLabel="income document" />;
}
